import Service from "./Service";

function ServicePage() {
  return <Service
    showHero={false}
    showBreadcrumbs={false}
  />;
}

export default ServicePage;
// i am an ui html css developer with 10 years experience as react developer what i have to learn